/* «Ещё 3 варианта» итога «Рилса» — дозаказ к тому же заказу (03-api §9.11 `POST /app/orders/{id}/more`). Одно ядро у родного хвоста
   (ReelsOrderResult.tsx) и у движка шаблона (reels-server.ts), поэтому ключ один: steos:reels:more:<заказ>:<ряд> — откат между ними
   повторяет тот же запрос тем же ключом. Порядок денег (I3): ключ ложится в sessionStorage до запроса (не легло — запроса нет),
   владелец проверяется заново (GET /app/me), затем POST с Idempotency-Key; ответ 2xx снимает ключ; неизвестный исход ключ оставляет —
   повторное нажатие проверит тот же запрос. Тексты исходов — те же, что у родного хвоста. */
import { api, endpoints } from '../../api';
import { ApiError, uuid } from '../../api/client';

export const moreKey = (order: number, group: string) => `steos:reels:more:${order}:${group}`;

/** Ключ неподтверждённого дозаказа ряда (тот же запрос при повторе) или null */
export function moreIntent(order: number, group: string): string | null {
  try {
    const value = sessionStorage.getItem(moreKey(order, group));
    return value && /^[0-9a-f-]{36}$/i.test(value) ? value : null;
  } catch {
    return null;
  }
}

/** sent — дозаказ принят (дальше — опрос заказа); poor — 402; closed — 409 (ряд без дозаказа); unknown — исход неизвестен (ключ остаётся) */
export type MoreOutcome = 'sent' | 'poor' | 'closed' | 'unknown';
export const MORE_NOTES: Record<Exclude<MoreOutcome, 'sent'>, string> = {
  poor: 'Не хватает Circle. Пополните баланс',
  closed: 'Для этого ряда ещё варианты недоступны',
  unknown: 'Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.',
};

/** Дозаказ ряда group заказа orderId по цене price от имени владельца owner (владелец заявки заказа) */
export async function postMore(o: { orderId: number; group: string; price: number; owner: number | undefined }): Promise<MoreOutcome> {
  const key = moreIntent(o.orderId, o.group) ?? uuid();
  try {
    sessionStorage.setItem(moreKey(o.orderId, o.group), key);
    const me = await endpoints.me();
    if (me.user.id !== o.owner) throw new Error('owner_changed');
    await api.request(`/app/orders/${o.orderId}/more`, { method: 'POST', body: { template_id: o.group, expected_price: o.price }, idempotency: key });
    sessionStorage.removeItem(moreKey(o.orderId, o.group));
    return 'sent';
  } catch (failure) {
    if (failure instanceof ApiError && failure.status === 402) return 'poor';
    if (failure instanceof ApiError && failure.status === 409) return 'closed';
    return 'unknown';
  }
}
